import navbarSearch from '../modules/navbar-search';
import {initializeAdmin} from '../modules/admin/hamburger';

let commonController = () => {
    // require('../modules/adblock').on();
    require('../modules/hamburger').on();
    require('../modules/hamburger-sections')();
    require('../modules/randomize-ab-nav')();
    navbarSearch.on();
    initializeAdmin();
};

export default commonController;
